
(function() {
  var result = { translations: { "ms": { "i18n": { "duration": { "seconds": "{{ seconds }} saat", "minutes": "{{ minutes }} min", "hours": "{{ hours }} jam", "hoursAndMinutes": "{{ hours }} jam {{ minutes }} min", "days": "{{ days }} hari", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}j", "days": "{{ days }}h", "hoursAndMinutes": "{{ hours }}j {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, samb. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ms": "static-7.1324"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1324",
    "ar-eg": "static-7.1324",
    "bg": "static-7.1324",
    "bn": "static-7.1324",
    "ca-es": "static-7.1324",
    "cs": "static-7.1324",
    "da": "static-7.1324",
    "de": "static-7.1324",
    "el": "static-7.1324",
    "en-gb": "static-7.1324",
    "en": "static-7.1324",
    "es-mx": "static-7.1324",
    "es": "static-7.1324",
    "et": "static-7.1324",
    "fi": "static-7.1324",
    "fr-ca": "static-7.1324",
    "fr": "static-7.1324",
    "he-il": "static-7.1324",
    "hi": "static-7.1324",
    "hr": "static-7.1324",
    "hu": "static-7.1324",
    "id": "static-7.1324",
    "it": "static-7.1324",
    "ja": "static-7.1324",
    "ko": "static-7.1324",
    "lt": "static-7.1324",
    "ms": "static-7.1324",
    "nl": "static-7.1324",
    "no": "static-7.1324",
    "pl": "static-7.1324",
    "pt-br": "static-7.1324",
    "pt-pt": "static-7.1324",
    "ro": "static-7.1324",
    "ru": "static-7.1324",
    "sk": "static-7.1324",
    "sl": "static-7.1324",
    "sv": "static-7.1324",
    "th": "static-7.1324",
    "tl": "static-7.1324",
    "tr": "static-7.1324",
    "uk": "static-7.1324",
    "vi": "static-7.1324",
    "x-pseudo": "static-7.1324",
    "zh-cn": "static-7.1324",
    "zh-hk": "static-7.1324",
    "zh-tw": "static-7.1324"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ms', {version: 'static-7.1324'}); }
})();


